import {
  Directive,
  HostListener,
  ContentChildren,
  QueryList,
} from '@angular/core';
import { TooltipDirective } from '@mhe/ngx-shared/tooltip';

@Directive({
  selector: '[rdrxHideOnEscape]',
  exportAs: 'rdrxHideOnEscape',
})
export class HideOnEscapeDirective {
  // support multiple mheTooltips on children, such as in a tab group
  @ContentChildren(TooltipDirective, { descendants: true }) tooltips!: QueryList<TooltipDirective>;

  @HostListener('keydown.Escape', ['$event'])
  handleEscapeKey(event: KeyboardEvent): void {
    const initialClosed = this.closeInitialContentTooltips();
    const nestedClosed = this.closeNestedTemplateTooltips();

    // If any tooltip was closed, stop propagation of the event.
    if (initialClosed || nestedClosed) {
      event.stopPropagation();
    }
  }

  private closeInitialContentTooltips(): boolean {
    let handled = false;
    this.tooltips.toArray().forEach(tooltip => {
      if (tooltip.isOpen()) {
        tooltip.close();
        handled = true;
      }
    });
    return handled;
  }

  private closeNestedTemplateTooltips(): boolean {
    let handled = false;
    Array.from(document.querySelectorAll('div[role="tooltip"]')).forEach((tooltipEl: HTMLElement) => {
      const parentTooltip = tooltipEl.closest('mhe-tooltip');
      if (parentTooltip) {
        // If the parent has a stored tooltip directive reference, close it.
        const tooltipDirective = (parentTooltip as any).__tooltipDirective;
        if (tooltipDirective) {
          tooltipDirective.close();
        } else {
          // Fallback: remove the parent element if no directive is stored.
          parentTooltip.remove();
        }
        handled = true;
      }
    });
    return handled;
  }
}
